// extracted by mini-css-extract-plugin
export var item = "mosaicitem-module--item--XRYeF";
export var logo = "mosaicitem-module--logo--3L_B4";